'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2016/10/25.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderListComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(OrderListComponent, _Component);

  function OrderListComponent() {
    (0, _classCallCheck3.default)(this, OrderListComponent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(OrderListComponent).call(this));
  }

  (0, _createClass3.default)(OrderListComponent, [{
    key: 'render',
    value: function render() {
      var styles = require('./ServiceOrderListComponent.scss');
      var order = this.props.order;

      var path = '';
      switch (order.status) {
        case '待审核':
          path = '/serviceorderconfirm/' + order.id;
          break;
        case '待确认':
          path = '/serviceorderconfirm/' + order.id;
          break;
        case '待支付':
          path = '/serviceorderconfirm/' + order.id;
          break;
        case '待交付':
          path = '/serviceorderacceptance/' + order.id;
          break;
        case '待验收':
          path = '/serviceorderacceptance/' + order.id;
          break;
        case '已结束':
          path = '/serviceorderacceptance/' + order.id;
          break;
        default:
      }

      var evaluateDiv = '';
      if (order.status === '已结束') {
        if (order.isEvaluated === '1') {
          evaluateDiv = _react2.default.createElement(
            _reactRouter.Link,
            { to: '/servicebuyevaluate/' + order.id, className: styles.evaluate },
            '已评价'
          );
        } else if (order.isEvaluated === '0') {
          evaluateDiv = _react2.default.createElement(
            _reactRouter.Link,
            { to: '/servicebuyevaluate/' + order.id, className: styles.evaluate },
            '未评价'
          );
        }
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.pagechildren },
          _react2.default.createElement(
            'div',
            { className: styles.childa, style: { width: '286px', textIndent: '10px' } },
            '订单号：',
            order.id
          ),
          _react2.default.createElement(
            'div',
            { className: styles.childa, style: { width: '250px' } },
            '时间：',
            order.date
          ),
          _react2.default.createElement(
            'div',
            { className: styles.childa, style: { width: '139px' } },
            '金额：',
            order.money
          ),
          _react2.default.createElement(
            'div',
            { className: styles.childa, style: { width: '195px' } },
            '商户：',
            order.shop
          ),
          _react2.default.createElement(
            'div',
            { className: styles.status },
            '状态：',
            order.status
          ),
          evaluateDiv,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: path, className: styles.childb },
            '订单详情'
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return OrderListComponent;
}(_react.Component), _class.propTypes = {
  order: _react.PropTypes.object.isRequired
}, _temp);
exports.default = OrderListComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceOrderListComponent/ServiceOrderListComponent.js
 ** module id = 1422
 ** module chunks = 0
 **/